import { useEffect, useState } from "react";
var totalOf = function (data) {
    var _a;
    return ({
        totalRecords: (_a = data.totalRecords) !== null && _a !== void 0 ? _a : 0,
        totalRecordsExact: data.totalRecordsExact !== false,
    });
};
/**
 * The total of the page on screen, derived from its query data — also when
 * the data comes from the cache, where react-query calls no `onSuccess`. While
 * the next search loads (no data yet) the last total stays, so the pager and
 * the subtitle do not drop to zero.
 *
 * @param data the data of the list query, undefined while it loads
 * @returns the total and whether it is exact
 */
export var usePageTotal = function (data) {
    var _a = useState({
        totalRecords: 0,
        totalRecordsExact: true,
    }), lastTotal = _a[0], setLastTotal = _a[1];
    useEffect(function () {
        if (data) {
            setLastTotal(totalOf(data));
        }
    }, [data]);
    return data ? totalOf(data) : lastTotal;
};
